import React, { memo } from 'react';

import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';

import { BACKEND_URL } from '../../constans';

const Img = styled(ListItem)(({ theme, img }) => ({
    padding: 0,
    height: '60px',
    width: '60px',
    borderRadius: '10px',
    backgroundImage: `url(${img})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    cursor: 'pointer',
    boxSizing: 'content-box',
    '&.active': { border: '3px solid #2bb656', borderRadius: '10px' },
    [theme.breakpoints.up('sm')]: {
        height: '80px',
        width: '80px',
        margin: '6px',
        '&.active': { margin: 0, border: '6px solid #2bb656' },
    },
}));

const StopImgGalleryItem = memo(({ img, indx, currentImg, handleChangeImg }) => {
    return (
        <Img
            img={`${BACKEND_URL}${img}`}
            onClick={() => handleChangeImg(img, indx)}
            className={currentImg === img ? 'active' : ''}
        />
    );
});

export default StopImgGalleryItem;
